import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon", "radio"]

  connect() {
    this._mediaQuery = matchMedia("(prefers-color-scheme: dark)")
    this._onSystemChange = () => this.applyMode()
    this._mediaQuery.addEventListener("change", this._onSystemChange)

    this._onStorage = (e) => {
      if (e.key === "theme-mode") this.applyMode()
    }
    window.addEventListener("storage", this._onStorage)

    this.applyMode()
  }

  disconnect() {
    this._mediaQuery.removeEventListener("change", this._onSystemChange)
    window.removeEventListener("storage", this._onStorage)
  }

  toggle() {
    const mode = this._stored()
    const isDark = mode === "dark" || (mode === "system" && this._mediaQuery.matches)
    this._save(isDark ? "light" : "dark")
    this.applyMode()
  }

  select(event) {
    this._save(event.target.value)
    this.applyMode()
  }

  applyMode() {
    const mode = this._stored()
    const dark = mode === "dark" || (mode === "system" && this._mediaQuery.matches)

    if (dark) {
      document.documentElement.setAttribute("data-mode", "dark")
    } else {
      document.documentElement.removeAttribute("data-mode")
    }

    // Update meta theme-color
    let meta = document.querySelector('meta[name="theme-color"]')
    if (!meta) {
      meta = document.createElement("meta")
      meta.name = "theme-color"
      document.head.appendChild(meta)
    }
    meta.content = dark ? "#0f1117" : "#ffffff"

    // Update icon visibility (match visual state, not stored mode)
    const visual = dark ? "dark" : "light"
    this.iconTargets.forEach((el) => {
      el.hidden = el.dataset.darkModeMode !== visual
    })

    // Sync radio buttons
    this.radioTargets.forEach((el) => {
      el.checked = el.value === mode
    })
  }

  _stored() {
    try {
      return localStorage.getItem("theme-mode") || "system"
    } catch {
      return "system"
    }
  }

  _save(mode) {
    try {
      localStorage.setItem("theme-mode", mode)
    } catch {
      // Private browsing
    }
  }
}
